import { createInjectionKey } from "../../_utils/vue/create-injection-key.mjs";
export const popoverBodyInjectionKey = createInjectionKey('n-popover-body');